import { EnvironmentSports } from '@bcf-shared-settings/settings/types';

export const environmentBase: Pick<EnvironmentSports, 'apiLanguageMap'> = {
  apiLanguageMap: {
    en: 'en-GB',
    pl: 'pl-PL',
    uk: 'uk-UA'
  }
};
